import axios from "../axios-auth";
import orginal_axios from "axios";

export const orderSaleReportService = {
    getOrderSaleReports,
    orderSaleReportExcel,
};

function getOrderSaleReports(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy,
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }
    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if(searchParams.ordNo){
        params["ordNo"] = searchParams.ordNo;
    }

    return axios.get("/auth/order-sale-reports", { params });
}

function orderSaleReportExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }
    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.ordNo) {
        params["ordNo"] = searchParams.ordNo;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/order-sale-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}